import {
    FETCH_LEARNING_HUB_REQUEST,
    FETCH_LEARNING_HUB_SUCCESS,
    FETCH_LEARNING_HUB_FAILURE,

    UPDATE_VIDEO_STATUS_REQUEST,
    UPDATE_VIDEO_STATUS_SUCCESS,
    UPDATE_VIDEO_STATUS_FAILURE,
    RESET_UPDATE_VIDEO_STATUS_SUCCESS
} from '../../../Constants/actionTypes'; // Ensure this path matches your setup


import { API_LEARNING_HUB, API_LEARNING_HUN_UPDATE_VIDEO_STATUS } from '../../../Constants/apiUrls'

import { fetchLearningHubData,updateVideoStatusLearningHub } from '../../../Constants/apiService'



export const fetchLearningHubRequest = () => ({
    type: FETCH_LEARNING_HUB_REQUEST,
});

export const fetchLearningHubSuccess = (data) => ({
    type: FETCH_LEARNING_HUB_SUCCESS,
    payload: data,
});

export const fetchLearningHubFailure = (error) => ({
    type: FETCH_LEARNING_HUB_FAILURE,
    payload: error,
});

export const updateVideoStatusRequest = () => ({
    type: UPDATE_VIDEO_STATUS_REQUEST,
});

export const updateVideoStatusSuccess = (data) => ({
    type: UPDATE_VIDEO_STATUS_SUCCESS,
    payload: data,
});

export const updateVideoStatusFailure = (error) => ({
    type: UPDATE_VIDEO_STATUS_FAILURE,
    payload: error,
});







export const fetchLearningHub = () => {
    return async (dispatch, getState) => {
        dispatch(fetchLearningHubRequest());

        // Retrieve access token from the state
        const state = getState();
        const accessToken = state.auth.accessToken;  // Adjust this according to your state structure

        try {
            const data = await fetchLearningHubData(accessToken);
            dispatch(fetchLearningHubSuccess(data));
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(fetchLearningHubFailure(errorMessage));
        }
    };
};



export const updateVideoStatus = (id, certName) => {
    return async (dispatch, getState) => {
        dispatch(updateVideoStatusRequest());

        // Retrieve access token from the state
        const state = getState();
        const accessToken = state.auth.accessToken; 
        try {
            const data = await updateVideoStatusLearningHub(accessToken,id, certName);
            dispatch(updateVideoStatusSuccess(data));
            return { success: true };
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(updateVideoStatusFailure(errorMessage));
            return { success: false, error };
        }
    };
};


